<template>
    <div>
        <v-combobox
            v-model="autocomplete.vModel"
            :items="autocomplete.items"
            :loading="autocomplete.isLoading"
            :search-input.sync="autocomplete.search"
            :error-messages="fieldErrors"
            :class="{ 'error--text': fieldErrors.length }"
            item-text="name"
            item-value="id"
            label="Denumire"
            data-vv-as="Denumire"
            placeholder="Tastati denumirea sau codul"
            @change="(ev) => { $emit('change', ev) }"
            return-object
            no-filter
        />
    </div>
</template>

<script>
import validationError from "Mixins/validation-error";
import throttle from 'lodash/throttle'

export default {
    mixins: [validationError],
    props: {
        value: {
            type: [Object, Number],
            default() {
                return null
            }
        },
        initialItems: {
            type: Array,
            default() {
                return []
            }
        },
        fieldErrors: {
            type: Array,
            default() {
                return []
            }
        },
        returnObject: {
            type: Boolean,
            default() {
                return false
            }
        },

    },
    data () {
        return {
            loading: true,
            autocomplete: {
                vModel: {
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    pivot: {
                        quantity: 1,
                        measurement: 0,
                        entry_amount: 0,
                        transport_cost: 0,
                        supplier_id: null,
                        unit_price: 0,
                        delivery_time: 0
                    }
                },
                items: this.initialItems.filter(item => !_.isNil(item?.id)),
                isLoading: false,
                search: null,
            }
        }
    },
    watch: {
        value: {
            handler(val) {
                this.handleValueChange(val)
            },
            deep: true
        },
        'autocomplete.vModel': {
            handler(val) {
                this.$emit('input', this.returnObject ? val : val?.id)
            },
            deep: true
        },
        'autocomplete.search': {
            handler: throttle(async function (val) {
                var self = this
                if (this.autocomplete.isLoading || this.loading || this._.isNil(val) || (val instanceof String && val.length < 3)) return
                this.autocomplete.isLoading = true
                await this.$db.Product
                    .where('autocomplete', val)
                    .get()
                    .then(({data}) => {
                        self.autocomplete.items = data
                    })
                    .finally(() => {
                        self.autocomplete.isLoading = false
                    })
            }, 500),
        }
    },
    mounted() {
        window.ProductComboBoxThrottle = 0
        this.handleValueChange(this.value)
        window.ProductComboBoxThrottle = 500
        this.loading = false
    },
    methods: {
        handleValueChange: throttle(async function (val) {
            if(!this._.isEqual(val, this.autocomplete.vModel)) {
                if(!this._.isNil(val)) {
                    if(val instanceof Object) {
                        this.autocomplete.items.push(val)
                        this.autocomplete.vModel = val
                    } else if (parseInt(val) > 0) {
                        var foundIndex = this.autocomplete.items.findIndex(item => item.id === val)
                        if(foundIndex >= 0) {
                            this.autocomplete.vModel = this.autocomplete.items[foundIndex]
                        } else {
                            this.$db.Product.find(val).then(({data}) => {
                                this.autocomplete.vModel = data
                                this.autocomplete.items.push(data)
                            })
                        }
                    }
                }
            }
        }, window.ProductComboBoxThrottle),
    }
};
</script>
